export default "/images/2cdac67dc43a95bb16f4523c4f1a15e9.avif";